import { forViewer, viewerIdOf } from "../../services/queries";
import type { AuthUser } from "../../types/authUser";

/** The same query the page uses, scoped to this person so a shared computer cannot serve the previous cache. */
export function viewQuery<T extends { queryKey: readonly unknown[] }>(
  user: AuthUser | null | undefined,
  options: T
): T {
  return forViewer(options, viewerIdOf(user));
}
